<template>
    <v-card>
        <v-card-title class="justify-center primary" icon @click="mostrar()" style="cursor: pointer;">
            <v-toolbar-title id="titulocard">Videos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-card-title>
        <v-expand-transition>
            <div v-show="show">
                <v-card-text style="margin-bottom: 4%;">
                    <v-row>
                        <v-col>
                            <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                :params="displayInputs" :order="[[0, 'desc']]" @apiDT="apiDT = $event" :movil="false"
                                @Cancelar="CancelarShow"></DataTable>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-row justify="center">
                    <v-dialog v-model="verarchi" content-class="dialogClass" persistent max-width="70%">
                        <v-card>
                            <v-card-title class="justify-center primary" icon>
                                <v-toolbar-title id="titulocard">{{ nombreArchivo }}</v-toolbar-title>
                                <v-spacer></v-spacer>

                                <v-btn icon @click="CerrarVisor()">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>

                            </v-card-title>
                            <v-card-text>
                                <v-progress-linear :active="loading" :indeterminate="loading" color="primary"
                                    class="mb-0"></v-progress-linear>
                                <div class="py-1 text-center">

                                    <v-row class="justify-center align-center">

                                        <v-col cols="12" md="10">
                                            <div id="ver" style="border-radius: 10%;">


                                            </div>
                                        </v-col>

                                    </v-row>
                                </div>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                                <v-btn dark color="error" @click="CerrarVisor()">
                                    Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-row>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Documentos from '@/services/documentos/documentos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';


//Tabla new
import DataTable from "@/components/pages/DataTableNet/DataTable";

export default {

    components: {
        DataTable
    },
    data: function () {
        return {
            urlListado: 'Documentos/ObtenerVideosAdjuntos',
            apiDT: null,
            columns: [
                { name: 'doiniciales', data: 'doiniciales', title: 'Iniciales' },
                { name: 'dodescrip', data: 'dodescrip', title: 'Descripción' },
                { name: 'docbaja', data: 'docbaja', title: 'Fecha expiración' },
                { name: 'vcuslogin', data: 'vcuslogin', title: 'Usuario Compartió' },
                { name: 'docid', data: 'docid', title: "", formatter: [this, "verVideoBtn"], orderable: false },
                { name: 'docid1', data: 'docid', title: "", formatter: [this, "DescargarVideoBtn"], orderable: false },
            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
            },
            formatterActions: [
                { click: [this, "VerVideo"] },
                { click: [this, "DescargarVideo"] },
            ],
            reporte: {
                nrreporte: '',
                svindice: '',
                aiclave: '',
            },
            cargando: false,
            show: true,
            encabezado: [
                { text: 'Iniciales', value: 'doiniciales', class: "text title" },
                { text: 'Descripción', value: 'dodescrip', class: "text title" },
                { text: 'Fecha de expiración', value: 'docbaja', class: "text title" },
                { text: 'Usuario Compartió', value: 'vcuslogin', class: "text title" },
                { text: 'Acciones', value: 'docid', class: "text title" },
            ],
            Documentos: [],
            verarchi: false,
            loading: false,
            nombreArchivo: '',
            docid: 0,
            aiclave: null,
            svfhconclusion: '',
            mostarBoton: 0,
            prefix: "tabla_",
            randomNum: Math.floor(Math.random() * 1000),
            loaded: false,
            cargando: false,
        }
    },
    props: [],
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
        tableName() {
            return this.prefix + this.randomNum;
        },
    },
    async mounted() {

        await this.DatosReporte();
    },
    async created() {

        this.DatosReporte();

        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');

        this.displayInputs = {
            nrreporte: datos.nrreporte,
            svindice: datos.svindice,
        };
        this.reloadTable();
    },
    methods: {
        CancelarShow() {
            this.cargando = false;
        },
        verVideoBtn(datos) {

            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" title="Ver Video" aria-expanded="false"><span style="color:white;" class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-play-circle-outline"></i></span></button></div>` : ``;
        },
        DescargarVideoBtn(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round v-size--small info dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos}" title="Descargar Video" aria-expanded="false"><span style="color:white;" class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-download-circle-outline"></i></span></button></div>` : ``;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        async DatosReporte() {

            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.reporte.nrreporte = datos.nrreporte;
            this.reporte.svindice = datos.svindice;
            this.reporte.aiclave = datos.aiclave;
        },
        CerrarVisor() {
            this.verarchi = false;

            const boxes = document.getElementById("gepa_1");
            boxes.remove();

        },
        mostrar() {

            if (this.show == true) {
                this.show = false;
                this.Documentos = [];
            } else {

                this.show = true;
                this.cargando = false;
            }
        },
        async Visitas(modulo, accion, nombre, destinatario) {
            var formData = new FormData();
            formData.append("lasitio", 'Siniestros');
            formData.append("lomodulo", modulo);
            formData.append("laaccion", accion);
            formData.append("lacaracteristicas", this.reporte.nrreporte + '-' + this.reporte.svindice);
            formData.append("lanombre", nombre);
            formData.append("ladestinatario", destinatario);
            Documentos.AlmacenarVisitas(formData).then(data => {
                //console.log(data);
            });
        },
        async VerVideo(params, datos, fila) {


            this.loaded = true;
            this.verarchi = true;
            this.nombreArchivo = datos.docarchivo;

            this.loading = true;


            await this.Visitas('Video', 'Ver Video', this.nombreArchivo, "");

            await new Promise(resolve => setTimeout(resolve, 2000));

            var blobMe = URL['createObjectURL'](new Blob([''], { type: 'text/html' }));
            var elIframe = document['createElement']('iframe');
            elIframe['setAttribute']('frameborder', '0');
            elIframe['setAttribute']('width', '100%');
            elIframe['setAttribute']('height', '510px');
            elIframe['setAttribute']('min-width', '380px');
            elIframe['setAttribute']('min-height', '500px');
            elIframe['setAttribute']('allowfullscreen', 'true');
            elIframe['setAttribute']('webkitallowfullscreen', 'true');
            elIframe['setAttribute']('mozallowfullscreen', 'true');
            elIframe['setAttribute']('src', blobMe);
            var idOne = 'gepa_1';
            elIframe['setAttribute']('id', idOne);
            document.getElementById('ver').appendChild(elIframe);


            const iframeHere = "https://player.vimeo.com/video/" + datos.rutaarchivo;
            document['getElementById'](idOne)['contentWindow']['document'].write('<script type="text/javascript">location.href = "' + iframeHere + '";\x3c/script>');

            this.loading = false;
        },
        async DescargarVideo(params, datos) {
            this.$swal({
                position: "center",
                icon: "info",
                title: "Información",
                html: "<p>Para descargar el video deberá seguir los siguientes pasos:</p> <br> <ul class='lista'><li>Se abrirá una alerta con el visualizador del video a descargar.</li><li>Deberá hacer clic en el botón <i class='mdi mdi-dots-vertical-circle-outline'></i> y seleccionar la opción de Descargar.</li></ul>",
                showConfirmButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#536DFE',
                confirmButtonText: 'Aceptar',
            }).then(async () => {
                this.$swal({
                    title: 'Cargando video, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let id = datos.rutaarchivo.split("?")[0]
                        let response = await Documentos.DescargarVideo(this, id);
                        let ruta = response.replace(/"/g, ''); // Esto quita todas las comillas de la cadena
                        // Si response contiene la URL de Vimeo
                        if (response.includes("vimeo.com")) {
                            // Limpiar la URL eliminando cualquier prefijo no deseado
                            this.loaded = true;
                            this.$swal.close();
                            this.verarchi = true;
                            this.nombreArchivo = datos.docarchivo;
                            this.loading = true;

                            await this.Visitas('Video', 'Descargar Video', this.nombreArchivo, "");
                            await new Promise(resolve => setTimeout(resolve, 2000));

                            var blobMe = URL['createObjectURL'](new Blob([''], { type: 'text/html' }));
                            var elIframe = document['createElement']('iframe');
                            elIframe['setAttribute']('frameborder', '0');
                            elIframe['setAttribute']('width', '100%');
                            elIframe['setAttribute']('height', '510px');
                            elIframe['setAttribute']('min-width', '380px');
                            elIframe['setAttribute']('min-height', '500px');
                            elIframe['setAttribute']('allowfullscreen', 'true');
                            elIframe['setAttribute']('webkitallowfullscreen', 'true');
                            elIframe['setAttribute']('mozallowfullscreen', 'true');
                            elIframe['setAttribute']('src', blobMe);
                            var idOne = 'gepa_1';
                            elIframe['setAttribute']('id', idOne);
                            document.getElementById('ver').appendChild(elIframe);

                            const iframeHere = ruta;
                            document['getElementById'](idOne)['contentWindow']['document'].write('<script type="text/javascript">location.href = "' + iframeHere + '";\x3c/script>');
                            this.loading = false;
                        } else {
                            console.error("La URL recibida no es válida", response);
                            this.$swal({
                                position: "center",
                                icon: "warning",
                                title: "Error",
                                text: "Ocurrió un error, al descargar el video, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                            });
                        }
                    }
                });
            });
        }
    },

}

</script>
<style scoped>
/*.v-data-table-header {
        font-weight: bold;
        background-color: success;
    }*/


#titulocard {
    color: white;
}

.boton_NC {
    display: flex;
    justify-content: center;
}

@media screen and (min-width: 600px) {
    .boton_NC {
        display: flex;
        justify-content: end;
    }

    .boton_Agregar {
        display: flex;
        justify-content: start;
    }
}

@media screen and (max-width: 599px) {
    .boton_NC {
        display: flex;
        justify-content: center;
    }

    .boton_Agregar {
        display: flex;
        justify-content: center;
    }
}



.centerInputs {
    margin-top: 2% !important;
    width: 70% !important;
    display: block !important;
    margin-right: auto !important;
    margin-left: auto !important;
    margin-bottom: 3% !important;
}

.dialogClass {
    width: 60% !important;
}




@media screen and (max-width: 1200px) {


    .dialogClass {
        width: 75% !important;
    }
}



@media screen and (max-width: 767px) {
    .select-registros {
        display: flex;
        justify-content: center;
        align-items: baseline;
    }

    .centerInputs {
        margin-top: 2% !important;
        width: 90% !important;
        display: block !important;
        margin-right: auto !important;
        margin-left: auto !important;
        margin-bottom: 3% !important;
    }

    .div-paginacion {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dialogClass {
        width: 80% !important;
    }
}


@media screen and (max-width: 500px) {


    .dialogClass {
        width: 100% !important;
        max-width: 100% !important;
    }


    .centerInputs {
        margin-top: 2% !important;
        width: 100% !important;
        display: block !important;
        margin-right: auto !important;
        margin-left: auto !important;
        margin-bottom: 3% !important;
    }
}
</style>

<style scoped>
html[data-bs-theme="dark"] div.dtsp-panescontainer div.dtsp-searchpane div.datatables_wrapper div.datatables_scrollbody {
    background: var(--bs-table-bg) !important;
    --bs-table-bg: var(--bs-table-bg) !important;
}


html[data-bs-theme="dark"] table {
    background: var(--bs-table-bg) !important;
    --bs-table-bg: var(--bs-table-bg) !important;
}


table {
    background: var(--bs-table-bg) !important;
    --bs-table-bg: var(--bs-table-bg) !important;
}
</style>

<style>
ul.lista {
    font-weight: 400;
    margin-left: 2em;
    text-align: left;
}

ul.lista li {
    list-style-type: number;
}
</style>